import Swiper from "swiper";
import noData from '@/components/noData/index.vue' //暂无数据
import {
    dataSource
} from "@/api/api";

export default {
    name: 'home',
    components: { //注册组件
        noData
    },
    data() {
        return {
            carouselArr: [],
            ifSwiper: true,
            swiperLength: '',
            autoplay: '',
            tabActiveIndex: "80010001",
            tabActiveName: '新闻资讯',
            //tabList: ["新闻资讯", "央行新闻", "央行服务", "政策法规", "通知公告"],
            tabList: [
                {
                    id: "80010001",
                    title: "新闻资讯"
                },
                {
                    id: "80010002",
                    title: "央行新闻"
                },
                {
                    id: "80010010",
                    title: "央行服务"
                },
                {
                    id: "80010003",
                    title: "政策法规"
                },
                {
                    id: "80010004",
                    title: "通知公告"
                },
                {
                    id: "80010008",
                    title: "企业贴息公示"
                }
            ],
            policyList: [],
            //分页配置
            page: {
                currentPage: 1, //当前页码
                total: 200, //总共条数
                pageSize: 10, //每页显示条数
                pageSizeList: [5, 10, 20], //每页显示条数切换
            },
            baseForm1: { //政策动态参数
                isHot: "",
                orders: [{
                    asc: true,
                    column: ""
                }],
                pageNum: 1,
                pageSize: 10,
                searchContent: "",
                searchCount: true,
                type: "80010001"
            },
            baseForm2: { //轮播参数
                isHot: "1",
                orders: [{
                    asc: true,
                    column: ""
                }],
                pageNum: 1,
                pageSize: 10,
                searchContent: "",
                searchCount: true,
                type: ""
            },
        }
    },
    computed: {
        updataNewsType() { //新闻类型
            return this.$store.state.newsType;
        },
    },
    watch: {
        updataNewsType: {
            handler() {
                //获取数据
                this.tabActiveIndex = this.$store.state.newsType;
                if (this.tabActiveIndex === "80010005") {
                    this.tabActiveName = "贴息政策"
                }
                this.tabList.map(item => {
                    if (this.tabActiveIndex == item.id) {
                        this.tabActiveName = item.title;
                    }
                })
                this.postIndexNewsFn();
            },
            immediate: true //立即调用
        }
    },
    methods: {
        //政策动态
        postIndexNewsFn() {
            this.baseForm1.pageNum = this.page.currentPage;
            this.baseForm1.pageSize = this.page.pageSize;
            this.baseForm1.type = sessionStorage.getItem("newsType") ? sessionStorage.getItem("newsType") : "80010001";
            dataSource.postIndexNews(this.baseForm1)
                .then(res => {
                    if (res.data.success) {
                        let data = res.data.data;
                        this.page.total = data.total;
                        this.page.currentPage = data.pageNum;
                        this.page.pageSize = data.pageSize;
                        console.log(data.list)
                        data.list.map(item => {
                            item.publicationTime = item.publicationTime.substring(0, 10)
                        })
                        this.policyList = data.list;

                    } else {
                        this.$message.error(res.data.msg)
                    }

                })
                .catch(err => {

                });
        },

        carouselArrFn() { //轮播
            let This = this;
            This.ifSwiper = false;
            dataSource.postIndexNews(this.baseForm2)
                .then(res => {
                    if (res.data.success) {
                        let data = res.data.data;
                        if (data.list.length) {
                            This.ifSwiper = true;
                            this.carouselArr = [];
                            data.list.map(item => {
                                item.publicationTime = item.publicationTime.substring(0, 10)
                                this.carouselArr.push(item)
                            })
                            This.swiperLength = This.carouselArr.length
                            This.$nextTick(function () {
                                if (This.swiperLength == 1) {
                                    This.autoplay = false;
                                } else {
                                    This.autoplay = { //是否自动滚动
                                        delay: 3000, //3秒切换一次
                                        disableOnInteraction: false,//触碰后不会停止自动切换
                                    }
                                }
                                This.mySwiper = new Swiper(".swiper-container-policy", {
                                    autoplay: This.autoplay,
                                    loop: true,
                                    pagination: {
                                        el: ".swiper-pagination",
                                        clickable: true
                                    },
                                    observer: true, //修改swiper自己或子元素时，自动初始化swiper
                                    observeParents: true, //修改swiper的父元素时，自动初始化swiper
                                })
                                This.mySwiper.el.onmouseover = function () { //鼠标放上暂停轮播
                                    This.mySwiper.autoplay.stop();
                                }
                                This.mySwiper.el.onmouseleave = function () {
                                    if (This.swiperLength > 1) {
                                        This.mySwiper.autoplay.start();
                                    }
                                }
                            })

                        } else {
                            this.carouselArr = [];
                        }

                    } else {
                        this.$message.error(res.data.msg)
                    }

                })
                .catch(err => {

                });
        },
        goInfo(tabActiveName, id) { //详情
            sessionStorage.setItem('dynamicId', id)
            sessionStorage.setItem('dynamicName', tabActiveName)
            if (tabActiveName == '贴息政策') {
                this.$router.push({ //详情
                    name: 'discountInfo',
                    params: {
                        tabActiveName: tabActiveName,
                        id: id
                    }
                })
            } else {
                this.$router.push({ //详情
                    name: 'dynamicInfo',
                    params: {
                        tabActiveName: tabActiveName,
                        id: id
                    }
                })
            }

        },
        //点击左侧切换
        tabActiveIndexFn(index, item) {
            this.tabActiveIndex = item.id;
            this.tabActiveName = item.title;
            this.page.currentPage = 1;
            sessionStorage.setItem("newsType", item.id);
            this.$store.commit('updataNewsType', item.id);
        },
        handleSizeChange(val) { //分页-每页显示条数切换
            this.page.pageSize = val;
            this.postIndexNewsFn();
        },
        handleCurrentChange(val) { //分页-页面切换
            this.page.currentPage = val;
            this.postIndexNewsFn();
        },

    },
    created() {
        this.tabActiveIndex = sessionStorage.getItem("newsType") ? sessionStorage.getItem("newsType") : "80010001";
        this.$store.commit('updataNewsType', sessionStorage.getItem("newsType") ? sessionStorage.getItem("newsType") : "80010001");
    },
    activated() {
    },
    mounted() {
        this.carouselArrFn();
    }
}